import React from 'react';
import { Link } from 'gatsby';
import ThemeToggle from './ThemeToggle';
let site = require('./../../siteConfig');

const Layout = props => {
  const { title, children } = props;
  const [toggleNav, setToggleNav] = React.useState(false);
  const closeNav = () => setToggleNav(false);
  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
        <div className="site-head-container">
          <a
            className="nav-burger"
            href={`#`}
            onClick={() => setToggleNav(!toggleNav)}
          >
            <div
              className="hamburger hamburger--collapse"
              aria-label="Menu"
              role="button"
              aria-controls="navigation"
            >
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </div>
          </a>
          <nav id="swup" className="site-head-left">
            <ul className="nav" role="menu">
              <li className="nav-about" role="menuitem">
                <Link to={`/about`} onClick={closeNav}>
                  About
                </Link>
              </li>
            </ul>
          </nav>
          <div className="site-head-center">
            <Link className="site-head-logo" to={`/`} onClick={closeNav}>
              {title}
            </Link>
          </div>
          <div className="site-head-right">
            <div className="social-links">
              <a
                href={site.github}
                title="GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
              <a
                href={site.linkedin}
                title="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <a
                href={site.cern_gitlab}
                title="CERN GitLab"
                target="_blank"
                rel="noopener noreferrer"
              >
                CERN Gitlab
              </a>
              {site.resume && (
                <a
                  href={site.resume}
                  title="CV"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CV
                </a>
              )}
            </div>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main">
        <div id="swup" className="transition-fade">
          {children}
        </div>
      </main>
      <footer className="site-foot">
        <div className="site-foot-inner">
          <span className="site-foot-copy">
            &copy; {new Date().getFullYear()} <Link to={`/`}>{title}</Link> &middot;
            Built with{' '}
            <a href="https://gatsbyjs.org" target="_blank" rel="noopener noreferrer">
              Gatsby
            </a>
          </span>
          <ThemeToggle />
        </div>
      </footer>
    </div>
  );
};

export default Layout;
